<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Kiểm tra lại tài liệu" icon="fas fa-check" />
    <div v-if="show">Tài liệu <b>{{ document.title }}</b> sẽ được kiểm tra lại.</div>
    <span slot="footer" v-if="show">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton :ref="refs.CONFIRM_BUTTON" type="primary" @click="checkDocument"> Kiểm tra lại </CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { apiCheckDocument } from "@/services/document_management_service"
import ModalHeader from "@/components/common/ModalHeader.vue"
import CommonButton from '@/components/common/CommonButton.vue'

export default {
  name: "DocumentCheckModal",
  components: {CommonButton, ModalHeader },
  data() {
    return {
      show: false,
      document: null,
      refs: {
        CONFIRM_BUTTON: "confirmButton",
      },
    }
  },
  methods: {
    openModal(document) {
      console.log(document)
      this.document = document
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async checkDocument() {
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
      const res = await apiCheckDocument(this.document.slug)
      if (res != null && res.status === "SUCCESS") {
        this.$message.success(res.description)
        this.show = false
        this.$emit("success")
      } else {
        this.$message.error("Có lỗi xảy ra")
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
    },
  },
}
</script>
